import { render, staticRenderFns } from "./NavigationDrawerGerenciarPeca.vue?vue&type=template&id=b5c15cd6&"
import script from "./NavigationDrawerGerenciarPeca.vue?vue&type=script&lang=js&"
export * from "./NavigationDrawerGerenciarPeca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports